/** Story chrome doesn't determine whether its content is video or images. */
export function renditionUsesVideo(
  format: "video" | "carousel" | "story",
  defaultVideo: boolean,
  videoOverride?: boolean,
): boolean {
  return format === "video" || (format === "story" && (videoOverride ?? defaultVideo));
}

/**
 * Whether a story slide is published as a 9:16 frame laid out from the slide
 * (phone story viewers zoom anything else to fill the screen). Mirrors
 * needsStoryFrame in server/src/services/CarouselToVideoService.ts.
 */
export function needsStoryFrame(item: {
  type?: string;
  metadata?: { dimensions?: { width?: number; height?: number } };
}): boolean {
  const { width, height } = item.metadata?.dimensions ?? {};
  return (
    item.type === "image" && !!width && !!height &&
    Math.abs(width / height - 9 / 16) >= 0.02
  );
}
